import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@icon/triangle_right.svg'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "team-selection__item" }
const _hoisted_3 = { class: "multiselect__option_team-name is-ellipsis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_icon = _resolveComponent("icon")!
  const _component_SprintHeading = _resolveComponent("SprintHeading")!
  const _component_DropdownTooltip = _resolveComponent("DropdownTooltip")!

  return (_ctx.selectedTeam)
    ? (_openBlock(), _createBlock(_component_DropdownTooltip, {
        key: 0,
        placement: "bottom-start",
        placementSub: "right-start",
        menu: _ctx.teamsOptions,
        popperClass: "team-selection header__breadcrumb-menu",
        popperClassSub: "sprint-selection header__breadcrumb-menu",
        optionMenuClass: "header__breadcrumb-menu-item",
        submenuWaitTitle: "sprints.notCompleleted",
        onDropdownSubMenu: _ctx.onTeamClick,
        onDropdownOptionMenu: _ctx.onMenuItemClick
      }, {
        "tooltip-label": _withCtx(() => [
          _createVNode(_component_BaseSubHeading, {
            size: "large",
            weight: "400",
            color: "monochrome-05",
            className: "header__breadcrumb"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" /"),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedTeamName), 1)
            ]),
            _: 1
          })
        ]),
        "tooltip-submenu-empty": _withCtx(({ item }) => [
          _createElementVNode("div", {
            class: "header__breadcrumb-menu-item empty-sprints-label",
            onClick: ($event: any) => (_ctx.createNewSprint(item))
          }, [
            _createVNode(_component_BaseSubHeading, {
              size: "large",
              weight: "400",
              class: "empty-label"
            }, {
              default: _withCtx(() => [
                _createTextVNode("No Sprints found")
              ]),
              _: 1
            }),
            _createVNode(_component_BaseSubHeading, {
              size: "large",
              weight: "500",
              class: "emply-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Create Sprint #" + _toDisplayString(_ctx.nextSprintNumber), 1)
              ]),
              _: 1
            })
          ], 8, _hoisted_1)
        ]),
        "tooltip-item": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Avatar, {
              src: item.team.picture?.pictureUrl,
              size: "sm",
              class: "team__avatar",
              type: "teamsGroup"
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.team?.name), 1),
            _createVNode(_component_icon, {
              width: "6px",
              height: "8px",
              data: _imports_0,
              fill: "false",
              color: "#363945",
              class: "team-selection__arrow"
            })
          ])
        ]),
        "tooltip-submenu-item": _withCtx(({ option }) => [
          _createVNode(_component_SprintHeading, {
            sprint: option,
            showDate: false,
            class: "sprint-label"
          }, {
            title: _withCtx(({ title }) => [
              _createVNode(_component_BaseSubHeading, {
                size: "large",
                weight: "400",
                color: "monochrome-07"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(title), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["sprint"])
        ]),
        _: 1
      }, 8, ["menu", "onDropdownSubMenu", "onDropdownOptionMenu"]))
    : _createCommentVNode("", true)
}